import RedactionTabCounterContext from '@/dataroom/application/redaction/RedactionTabCounterContext';

const RedactionLayout = ({ children }) => {
  return (
    <RedactionTabCounterContext>
      { children }
    </RedactionTabCounterContext>
  );
};

export default RedactionLayout;
